import React, { useState } from "react";
import InputWithoutTitle from "../../../components/InputWithoutTitle";
import Dropdown from "../../../components/Dropdown";
import Pagination from "../../../components/Pagination";
import ButtonSelectedItems from "../../../components/ButtonSelectedItems";
import CheckItem from "../../../components/CheckItem";
import AddIllnessDialog from "./AddIllnessDialog";
import HistoryillnessTable from "./HistoryillnessTable";
export default function HistoryillnessPage() {
  const [dialog, setdialog] = useState(false);

  return (
    <div className="pt2">
      <div className="grid70-30">
        <InputWithoutTitle />
        <Dropdown
          items={["1/2564", "2/2564", "1/2563", "2/2563"]}
          itemCallback={(item) => {
            console.log(item);
          }}
          hasFilter={true}
        />
      </div>
      <div className="box-on-top-history_illness-page">
        <div className="box-dash-history_illness-page">
          <div className="row-jcsb">
            <p className="txt-main-content4">Hight-Temp-Number</p>
            <p className="txt-main-content4">135 คน</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Most Temp</p>
            <p className="txt-main-content4">39.5</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Env Temp</p>
            <p className="txt-main-content4">36.8</p>
          </div>
        </div>
        <div className="box-dash-history_illness-page">
          <div className="row-jcsb">
            <p className="txt-main-content4">Hight-Temp-Number</p>
            <p className="txt-main-content4">135 คน</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Most Temp</p>
            <p className="txt-main-content4">39.5</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Env Temp</p>
            <p className="txt-main-content4">36.8</p>
          </div>
        </div>
        <div className="box-dash-history_illness-page">
          <div className="row-jcsb">
            <p className="txt-main-content4">Hight-Temp-Number</p>
            <p className="txt-main-content4">135 คน</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Most Temp</p>
            <p className="txt-main-content4">39.5</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Env Temp</p>
            <p className="txt-main-content4">36.8</p>
          </div>
        </div>
      </div>
      <HistoryillnessTable />
      <div className="row-jcfe-my2">
        <Pagination />
      </div>
      <ButtonSelectedItems
        addClick={() => {
          setdialog(true);
        }}
        addTitle={"Add illness"}
      />
      <AddIllnessDialog
        isShow={dialog}
        backgroundClick={() => {
          setdialog(false);
        }}
        cancelClick={() => {
          setdialog(false);
        }}
      />
    </div>
  );
}
